export enum CorrespondenceAddressSelectionEnum {
  CoOwner1HomeAddress = 'coowner1_homeAddress',
  CoOwner1LegalAddress = 'coowner1_legalAddress',
  CoOwner2HomeAddress = 'coowner2_homeAddress',
  CoOwner2LegalAddress = 'coowner2_legalAddress',
  Different = 'different',
  OwnerHomeAddress = 'owner_homeAddress',
  OwnerLegalAddress = 'owner_legalAddress',
}
